import React, { useContext, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import CompanyService from '../../../core/service/CompanyService';
import UtilsService from '../../../core/service/UtilsService';
import './GHGEmissions.scss';
import { FaAngleDoubleRight, FaAngleDoubleDown } from 'react-icons/fa';
import { Button, Form, Modal, OverlayTrigger, Table, Tooltip } from 'react-bootstrap';
import { toast } from "react-toastify";
import ProfileSettingsService from '../../../core/service/ProfileSettingsService';
import { BiPlusCircle, BiPlus, BiShow, BiPencil, BiTrash } from 'react-icons/bi';
import GHGEmissionService from '../../../core/service/GHGEmissionService';
import { LoaderContext } from '../../../App';
import { useNavigate } from 'react-router-dom';
import Nodataimg from "../../../images/Assessment.png";


const GHGOrgBoundaries = ({ t, filterData, nextPage, setHasUnsavedData, registerSaveHandler, gotoPage }) => {

  const data = JSON.parse(localStorage.getItem("authority"));
  const companyId = data.profile.company.id;
  const { setLoaderDisplay } = useContext(LoaderContext);
  const [companyDetails, setCompanyDetails] = useState(null);
  const [nodes, setNodes] = useState([]);
  const [countries, setCountries] = useState([]);
  const [modalDisplay, setModalDisplay] = useState(false);
  const [nodeId, setNodeId] = useState(0);
  const [parentId, setParentId] = useState(0);
  const [selectedNode, setSelectedNode] = useState(null);
  const [draggedNode, setDraggedNode] = useState({});
  const [draggedOver, setDraggedOver] = useState({ nodeId: null, parentId: null });
  const [expandedNodes, setExpandedNodes] = useState({});
  const [selectedItems, setSelectedItems] = useState([]);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [displayData, setDisplayData] = useState({});
  const [hasUnsavedData, setLocalHasUnsavedData] = useState(false);

  useEffect(() => {
    getCompanyDetails(companyId);
    getEnterpriseStructure();
  }, [])

  useEffect(() => {
    getOrgBoundaries();
  }, [filterData])

  useEffect(() => {
    if (registerSaveHandler) {
      registerSaveHandler((nav) => saveOrgBoundaries(nav));
    }
  }, [selectedItems, filterData]);

  const getCompanyDetails = async (companyId) => {
    ProfileSettingsService.getCompanyDetails(companyId)
      .then((response) => {
        let data = response.data;
        setCompanyDetails(data);
      })
      .catch((error) => {
      });
  };

  const getEnterpriseStructure = () => {
    setLoaderDisplay(true);
    CompanyService.getEnterpriseStructure()
      .then(res => {
        setLoaderDisplay(false);
        if (res.status !== 200) return;
        setNodes(res.data.data ?? []);
      })
      .catch(err => {
        setLoaderDisplay(false);
      });
  };

  const handleClose = () => {
    setShowModal(false);
    setDisplayData({});
  };

  const findNodeById = (nodes, id) => {
    for (const node of nodes) {
      if (node.id === id) return node;
      if (node.children) {
        const found = findNodeById(node.children, id);
        if (found) return found;
      }
    }
    return null;
  };

  const getAllParentIds = (nodes, id) => {
    const parentIds = [];
    let currentId = id;

    while (true) {
      const parent = findParent(nodes, currentId);
      if (!parent) break;
      parentIds.push(parent.id);
      currentId = parent.id;
    }

    return parentIds;
  };

  const findParent = (nodes, childId, parent = null) => {
    for (const node of nodes) {
      if (node.id === childId) return parent;
      if (node.children) {
        const found = findParent(node.children, childId, node);
        if (found) return found;
      }
    }
    return null;
  };

  const onSelection = (id) => {
    const node = findNodeById(nodes, id);
    if (!node) return;

    let newSelectedItems = [...selectedItems];
    const isSelected = newSelectedItems.includes(id);

    if (isSelected) {

      newSelectedItems = newSelectedItems.filter(itemId => itemId !== id);
      newSelectedItems = deselectAllChildren(node, newSelectedItems);

      const parentIds = getAllParentIds(nodes, id);
      parentIds.forEach(parentId => {
        const parentNode = findNodeById(nodes, parentId);
        if (parentNode && parentNode.children) {
          const hasSelectedChildren = parentNode.children.some(child =>
            newSelectedItems.includes(child.id)
          );
          if (!hasSelectedChildren) {
            newSelectedItems = newSelectedItems.filter(itemId => itemId !== parentId);
          }
        }
      });
    } else {
      newSelectedItems.push(id);
      if (node.children) {
        node.children.forEach(child => {
          if (!newSelectedItems.includes(child.id)) {
            newSelectedItems.push(child.id);
          }
        });
      }

      const parentIds = getAllParentIds(nodes, id);
      parentIds.forEach(parentId => {
        if (!newSelectedItems.includes(parentId)) {
          newSelectedItems.push(parentId);
        }
      });

      if (node.children && node.children.length > 0) {
        setExpandedNodes(prev => ({ ...prev, [node.id]: true }));
      }
    }

    setSelectedItems([...new Set(newSelectedItems)]);
    setLocalHasUnsavedData(true);
    setHasUnsavedData(true);
  };

  const selectAllChildren = (node, selectedIds) => {
    if (!node) return selectedIds;

    let newSelectedIds = [...selectedIds];
    if (node.id && !newSelectedIds.includes(node.id)) {
      newSelectedIds.push(node.id);
    }

    if (node.children) {
      node.children.forEach(child => {
        newSelectedIds = selectAllChildren(child, newSelectedIds);
      });
    }

    return newSelectedIds;
  };

  const deselectAllChildren = (node, selectedIds) => {
    if (!node) return selectedIds;

    let newSelectedIds = selectedIds.filter(id => id !== node.id);

    if (node.children) {
      node.children.forEach(child => {
        newSelectedIds = deselectAllChildren(child, newSelectedIds);
      });
    }

    return newSelectedIds;
  };

  const toggleNode = (node) => {
    setExpandedNodes(prev => ({
      ...prev,
      [node.id]: !prev[node.id]
    }));

    if (!node.children) {
      CompanyService.getChildren(node.id).then(res => {
        if (res.status === 200) {
          setNodes(prevNodes => {
            const updateNodes = (nodes) => {
              return nodes.map(n => {
                if (n.id === node.id) {
                  return { ...n, children: res.data.data };
                }
                if (n.children) {
                  return { ...n, children: updateNodes(n.children) };
                }
                return n;
              });
            };
            return updateNodes(prevNodes);
          });
        }
      });
    }
  };

  const renderNodes = (nodes, parent, depth = 0) => {
    return (
      <ul>
        {nodes?.length > 0 && nodes?.sort((a, b) => a.sortOrder - b.sortOrder)?.map((node, index) => {
          const hasChildren = node.children && node.children.length > 0;
          const isSelected = selectedItems.includes(node.id);
          const shouldExpand = expandedNodes[node.id] || isSelected;

          return (
            <li key={`node-${node.id}-${index}`}>
              {draggedOver.nodeId === node.id && <NodeDropSpacer />}
              <div className='node-holder'>
                <div className='tree_box' draggable={false}>
                  <div className='tree_box_body'>
                    <h6 className='fw-600 cursor' onClick={() => { setDisplayData(node); setShowModal(true) }}>
                      {node.name}
                    </h6>
                    <div className='d-flex justify-content-between align-items-end'>
                      <div>
                        <div className='Unittype_box'>{node.unitType?.name}</div>
                        <div className='text-muted'>{node.code}</div>
                      </div>
                      <div className="checkboxesCircle">
                        <label className="checkbox style-d">
                          <input
                            type="checkbox"
                            className="form-check-input cursor"
                            checked={isSelected}
                            onChange={() => onSelection(node.id)}
                          />
                          <div className="checkbox__checkmark"></div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {hasChildren && (
                <div className='toggle-btn'>
                  <div className='toggle-btn_inner'>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>{t("ShowChildEntitiesToolTip.label")}</Tooltip>}
                    >
                      <div className='toggle-button' onClick={(e) => { e.stopPropagation(); toggleNode(node); }}>
                        {shouldExpand ? <FaAngleDoubleDown /> : <FaAngleDoubleRight />}
                      </div>
                    </OverlayTrigger>
                  </div>
                </div>
              )}

              {shouldExpand && hasChildren && renderNodes(node.children, node, depth + 1)}
            </li>
          );
        })}
      </ul>
    );
  };

  const getOrgBoundaries = () => {
    // setLoaderDisplay(true);
    const date = filterData?.year + '-01-01';
    GHGEmissionService.getOrgBoundaries(companyId, date)
      .then((response) => {
        // setLoaderDisplay(false);
        if (response.status !== 200) return;
        const selectedIds = response.data.data.map(item => item.businessUnitId);
        setSelectedItems(selectedIds);
        setLocalHasUnsavedData(false);
        setHasUnsavedData(false);
      })
      .catch((error) => {
        // setLoaderDisplay(false);
      });
  }

  const saveOrgBoundaries = async (nav) => {
    if (selectedItems.length > 0) {
      setLoaderDisplay(true);
      let passData = [];
      selectedItems.forEach(el => {
        passData.push({
          businessUnitId: el
        });
      })
      const date = filterData?.year + '-01-01';
      try {
        const response = await GHGEmissionService.saveOrgBoundaries(companyId, date, passData);
        setLoaderDisplay(false);
        if (response.status !== 200) return false;
        toast.success(t("OrgBoundariesSavedSuccess.label"), {
          position: toast.POSITION.TOP_RIGHT,
        });
        setLocalHasUnsavedData(false);
        setHasUnsavedData(false);
        if (nav == 'next') {
          nextPage('Opr');
        }
        return true;
      } catch (error) {
        setLoaderDisplay(false);
        return false;
      }
    } else if (selectedItems.length == 0) {
      toast.warning(t("SelectAtLeastOneBeforeNextStep.label"), {
        position: toast.POSITION.TOP_RIGHT,
      });
      return false;
    } else {
      toast.warning(t("SelectAtLeastOneToSave.label"), {
        position: toast.POSITION.TOP_RIGHT,
      });
      return false;
    }
  }

  const gotoEnterprise = () => {
    let tabKey = 'epStruct';
    navigate('/company_admin/company_settings', { state: { tabKey } });
  }

  return (
    <>
      <div className="List_header mb-1">
        <div>
          <span>{t('OrgBoundaryHead.label')}</span>
        </div>
        {
          nodes.length > 0 &&
          <div className='GHGInventory_btn_head'>
            <Button variant='primary' onClick={() => gotoEnterprise()}><BiPlus /> {t("AddEnterprise.label")}</Button>
          </div>
        }
      </div>
      {nodes.length > 0 &&
        <>
          <div className='tree'>
            <ul>
              <li>
                <div className='Main_company tree_box'>
                  <div className='tree_box_head'>
                    <b>{companyDetails?.legalName}</b>
                    {
                      companyDetails?.regNumber &&
                      <div>ID : {companyDetails?.regNumber}</div>
                    }
                  </div>
                  <div className='tree_box_body'>
                    {
                      companyDetails?.address &&
                      <div className='mb-1'>
                        <div className='text-muted'>{t('Address.label')}</div>
                        {
                          (companyDetails?.address?.building || companyDetails?.address?.street) &&
                          `${companyDetails?.address?.building ?? ''} ${companyDetails?.address?.building ? ', ' : ''}${companyDetails?.address?.street ?? ''}`
                        }
                        {
                          (companyDetails?.address?.city || companyDetails?.address?.state) &&
                          `${companyDetails?.address?.city ?? ''} ${companyDetails?.address?.city ? ', ' : ''}${companyDetails?.address?.state?.name ?? ''}`
                        }
                        {companyDetails?.address?.country && <span>, {companyDetails?.address?.country?.name}</span>}
                        {companyDetails?.address?.zipCode && <span> - {companyDetails?.address?.zipCode}</span>}
                      </div>
                    }
                    {
                      companyDetails?.primaryContact &&
                      <div className='mb-1'>
                        <div className='text-muted'>{t('ContactPerson.label')}</div>
                        <div>{companyDetails?.primaryContact.name}</div>
                        <div>{companyDetails?.primaryContact.contactNumber?.number}</div>
                      </div>
                    }
                  </div>
                </div>
                {renderNodes(nodes, null)}
              </li>
            </ul>
          </div>
          <div className='GHGInventory_cardFooter text-center  p-2 pt-3'>
            {/* <Button variant='primary' className='px-4 me-2' onClick={() => saveOrgBoundaries()}>{t('Save.label')}</Button> */}
            <Button variant='secondary' className='px-4' onClick={() => saveOrgBoundaries('next')}>{t('Next.label')}</Button>
          </div>
        </>
      }

      {nodes.length == 0 &&
        <>
          <div className='col-lg-12 px-0 py-2 text-center'>
            <div className='noDataCard'>
              <div>
                <div className='Nodataimg_box'>
                  <img src={Nodataimg} />
                </div>
                <h5 className='py-3'>{t("NoEnterpriseStructure.label")}</h5>
                <Button variant="primary" className="px-3 mx-2" onClick={() => gotoEnterprise()}>
                  {t("GotoEnterprise.label")}
                </Button>
              </div>
            </div>
          </div>
        </>
      }

      {
        showModal &&
        <Modal
          show={true}
          onHide={handleClose}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered>
          <Modal.Header closeButton>
            < Modal.Title as="h5">
              {t("ViewEnterprise.label")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="ViewEntity_card">
              <div className="ViewEntity_card_head">
                <Table size="sm" className="m-0">
                  <tbody>
                    <tr>
                      <td>{t("Name.label")}</td>
                      <td>:</td>
                      <td><h6 className="fw-bold">{displayData?.name}</h6></td>
                    </tr>
                    <tr>
                      <td>{t("Type.label")}</td>
                      <td>:</td>
                      <td><h6>{displayData?.unitType?.name}</h6></td>
                    </tr>
                    <tr>
                      <td>{t("Code.label")}</td>
                      <td>:</td>
                      <td><h6>{displayData?.code} </h6></td>
                    </tr>
                    <tr>
                      <td>{t("Address.label")}</td>
                      <td>:</td>
                      <td>
                        <h6>
                          {
                            (displayData?.address?.building || displayData?.address?.street) &&
                            `${displayData?.address?.building ?? ''} ${displayData?.address?.building ? ', ' : ''}${displayData?.address?.street ?? ','}`
                          }
                          {
                            (displayData?.address?.city || displayData?.address?.state) &&
                            `${displayData?.address?.city ?? ', '} ${displayData?.address?.city ? ', ' : ''}${displayData?.address?.state?.name ?? ''}`
                          }
                          {displayData?.address?.country && <span>, {displayData?.address?.country?.name}</span>}
                          {displayData?.address?.zipCode && <span> - {displayData?.address?.zipCode}</span>}
                        </h6>
                      </td>
                    </tr>
                    {
                      displayData?.emails &&
                      <>
                        <tr>
                          <td>{t("Email.label")}</td>
                          <td>:</td>
                          <td>
                            {
                              displayData?.emails?.map(e => {
                                return <h6>{e}</h6>;
                              })
                            }
                          </td>
                        </tr>
                      </>
                    }
                    {
                      displayData?.reviewers?.length > 0 &&
                      <>
                        <tr>
                          <td>{t("Reviewer.label")}</td>
                          <td>:</td>
                          <td>
                            {
                              displayData?.reviewers?.map(r => {
                                return <h6>{r.name ?? ''}</h6>;
                              })
                            }
                          </td>
                        </tr>
                      </>
                    }
                  </tbody>
                </Table>
              </div>
            </div >
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              {t("Cancel.label")}
            </Button>
          </Modal.Footer>
        </Modal>
      }
    </>
  );
}

export default withTranslation()(GHGOrgBoundaries);

const NodeDropSpacer = () => {
  return (
    <div className="pt-3 pb-3"
      style={{ backgroundColor: 'lightcyan' }}>
    </div>
  );
};